import React from 'react'

export const floridaSetupVars = {
  siteId: 'florida',
  pathPrefix: '/fl',
  menuHeader: "Discover Florida's Solution for:",
  appUrl: 'https://fl.headed2.com',
  logoImg: '/images/assets/florida/horizontal/dark.svg',
  headerTitle: `The Florida CareerExplorer is a system designed for Florida`
}
